export function withIndex(fn) {
  let index = 0
  let enhancedFunction = function(...args) {
    return fn.call(this, ...args, index++)
  }

  return enhancedFunction
}

export function validatePassword(newPassword, confirmation, currentPassword = '') {
  if (!newPassword || !confirmation)
    return null

  const specialCharacters = /[ `!@#$%^&*()_+\-=\[\]{};':"\\|,.<>\/?~]/

  if (currentPassword && newPassword === currentPassword)
    return 'A nova senha não pode ser igual a senha anterior'

  if (newPassword.length < 8)
    return 'A senha precisa de ao menos 8 caracteres'

  if (!newPassword.match(specialCharacters))
    return 'A senha precisa conter 1 caracter especial'

  if (newPassword !== confirmation)
    return 'As senhas precisam ser iguais'

  return null
}

export function validateEmail(emailFromUser) {
  const EMAIL_REGEX = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/

  const email = String(emailFromUser).toLowerCase()

  if (!email.includes('.'))
    return 'O e-mail precisa conter um .'

  if (!email.includes('@'))
    return 'O e-mail precisa conter um @'

  if (!email.match(EMAIL_REGEX))
    return 'O e-mail digitado está inválido'

  return null
}
